<template>
  <div class="m-confirm-payment">
    <div class="m-confirm-payment__fields-container">
      <base-checkbox
        v-model="value.isTermsAccepted"
        v-validate="{ required: { allowFalse: false } }"
        name="acceptTerms"
        :invalid="isTermsAndConditionsAccepted"
        required
        @change="updateField('isTermsAccepted', $event)"
      >
        <template v-slot:label>
          <div class="a-checkbox__label">
            {{ $t("acceptAll", "Jeg accepterer alle") }}&nbsp;
            <base-link
              :link="termsAndConditionsLink"
              target="_blank"
            >
              {{ $t("termsAndConditions", "handelsbetingelser") }}
            </base-link>
          </div>
        </template>
      </base-checkbox>
      <base-checkbox
        v-if="marketingTermsAndConditionsPage"
        v-model="value.isMarketingTermsAccepted"
        name="acceptMarketingTerms"
        class="mt-4"
        @change="updateField('isMarketingTermsAccepted', $event)"
      >
        <template v-slot:label>
          <div class="a-checkbox__label">
            {{ $t("marketingTermsAndConditionsPrefix", "Jeg accepterer") }}&nbsp;
            <base-link
              :link="marketingTermsAndConditionsLink"
              target="_blank"
            >
              {{ $t("marketingTermsAndConditions", "marketingbetingelser") }}
            </base-link>
          </div>
        </template>
      </base-checkbox>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from '@/components/atoms/BaseCheckbox.vue';
import BaseLink from '@/components/atoms/BaseLink.vue';

export default {
  name: 'ConfirmPayment',
  components: {
    BaseCheckbox,
    BaseLink
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    termsAndConditionsPage: {
      type: Object,
      required: true
    },
    marketingTermsAndConditionsPage: {
      type: Object,
      default: null
    },
    hasGoToPaymentBeenClicked: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    termsAndConditionsLink () {
      return this.termsAndConditionsPage?.url;
    },
    marketingTermsAndConditionsLink () {
      return this.marketingTermsAndConditionsPage?.url;
    },
    isTermsAndConditionsAccepted () {
      return this.hasGoToPaymentBeenClicked && !this.value.isTermsAccepted;
    }
  },
  methods: {
    updateField (fieldName, fieldValue) {
      this.$emit('change', {
        ...this.value,
        [fieldName]: fieldValue,
      });
    },
  },
}
</script>
